var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6086_158429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1167 0.881433C18.5501 0.315764 17.7823 -0.00195312 16.9817 -0.00195312C16.1811 -0.00195312 15.4132 0.315764 14.8467 0.881433L0 15.7281V19.9981H4.27L19.1167 5.15143C19.6821 4.58479 19.9997 3.81696 19.9997 3.01643C19.9997 2.21591 19.6821 1.44808 19.1167 0.881433ZM3.58333 18.3314H1.66667V16.4148L12.7583 5.33143L14.675 7.2481L3.58333 18.3314ZM17.9383 3.9731L15.8492 6.06227L13.9367 4.1456L16.025 2.05977C16.2792 1.8056 16.6239 1.66281 16.9833 1.66281C17.3428 1.66281 17.6875 1.8056 17.9417 2.05977C18.1958 2.31393 18.3386 2.65865 18.3386 3.0181C18.3386 3.37754 18.1958 3.72227 17.9417 3.97643L17.9383 3.9731Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6086_158429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.54fed583cf7d388c3f5646a9b688693a.svg";
export { ForwardRef as ReactComponent };